<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<h3 class="page-header">Add a new Namespace</h3>
		</template>

		<template slot="admin-page-content">
			<div class="row">
				<form>
					<div class="row">
						<div class="col-xs-6">
							<div class="form-group">
								<label>Name</label>
								<input v-model="name" class="form-control tests_namespace_name_input" placeholder="">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-6">
							<button type="button" @click="addNamespace()" class="btn btn-primary tests_namespace_create_action">Create</button>
						</div>
					</div>
				</form>
			</div>
		</template>
	</admin-base-layout>
</template>



<script>
const namespaceService = require("@/utils/namespace-api");
import router from "@/router";
const utils = require("@/utils/utils");
const logger = require("@/utils/logger");

export default {
  data() {
    return {
      name: ""
    };
  },
  methods: {
    addNamespace() {
      logger.log("Adding namespace " + this.name);

      if (/^[a-zA-Z0-9_\-\. ]{5,}$/.test(this.name)) {
        namespaceService
          .create(this.name)
          .then(namespaces => {
            router.push("/namespaces");
          })
          .catch(utils.axiosErrorHandler);
      } else {
        alert("Invalid namespace name: 5 characters mininum, letters, digits, dashes, dots, underscores and spaces please!");
      }
      return false;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AddNamespace.vue